import FileSaver from 'file-saver'

// WHY: BE が encoding_type クエリで指定された文字コード（Shift-JIS/UTF-8/Windows-31J）に
// エンコード済みの CSV を返す。FE 側で再エンコードすると文字コードが壊れるため、
// 受け取った blob をそのまま保存するだけにする。
export const saveCsvBlob = (blob: Blob, filename: string): void => {
  FileSaver.saveAs(blob, filename)
}
